<template>
  <div class="list">
    <van-nav-bar
      :title="'重考审核'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <van-row class="xitem" justify="space-between">
      <van-col span="24">
        <p>学号：{{ form.studentnumber }}</p>
        <p>姓名：{{ form.studentname }}</p>
        <p>申请人：{{ form.teachername }}</p>
        <p>申请时间：{{ form.sqsj }}</p>
        <p>申请原因：{{ form.sqyy }}</p>
      </van-col>
    </van-row>
    <van-row class="xitem" justify="space-between">
      <div style="padding-top: 10px;padding-bottom: 10px">
        <van-radio-group v-model="form.shzt" direction="horizontal" :disabled="iscz">
          <van-radio name="1">审核通过</van-radio>
          <van-radio name="0">审核不通过</van-radio>
        </van-radio-group>
      </div>
      <div style="padding-left: 10px;padding-top: 10px;padding-bottom: 10px" v-if="form.kfzj == '1' ? true : false">
        <van-checkbox v-model="form.sfzj" shape="square" :disabled="iscz">终结流程</van-checkbox>
      </div>
      <div style="padding-top: 10px;padding-bottom: 10px">
        <van-field v-model="form.shyj" type="textarea" label="" placeholder="审核意见" :disabled="iscz" />
      </div>
      <div style="text-align: center">
        <van-button type="info" size="small" @click="cksh" :disabled="iscz">审 核</van-button>
      </div>
    </van-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:true,
        showzj:false,
        iscz:true,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderColumn:undefined,
          orderState:undefined,
        },
        id:null,
        form: {
          resitid:null,
        },
        formsh:{
          dataid:null,
        }
      }
    },
    created() {
      this.getcksh();
    },
    methods: {
      onClickLeft() {
        this.$router.push({ name: 'ckshindex'})
      },
      enterTest(id) {
        this.show = true;
      },
      getcksh() {
        this.id = this.$route.params.id;
        this.formsh.dataid = this.id;
        let that = this;
        this.$ajax.get('/examsys/examresitsh/sh/'+this.id).then(function (res) {
          if (res.code == 200) {
            that.form = res.data;
            if(that.form.shzt === '2'){
              that.iscz = false;
            }
            that.loading = false;
          }
        })
      },
      cksh() {
        this.$dialog.confirm({
          title: "重考审核",
          message: "确定要审核吗？",
          messageAlign: 'center'
        }).then(() => {
          if (this.form.shzt == '1' || this.form.shzt == '0') {
            this.formsh.shzt = this.form.shzt;
            this.formsh.shyj = this.form.shyj;
            this.formsh.sfzj = this.form.sfzj;
            this.$ajax.put('/examsys/examresitsh/sh', this.formsh).then(response => {
              this.$toast('审核成功')
              this.$router.push({name: 'ckshindex'})
            });
          } else {
            this.$toast('请选择审核状态')
          }
        }).catch(() => {

        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .xitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/ckshdo.vue